<template>
    <ass-detail :item="info.item" :message="info" v-if="info"></ass-detail>
</template>

<script>
    import AssDetail from "../../layouts/AssDetail";
    export default {
        name: "AssApproveDetail",
        components: {
            AssDetail
        },
        data() {
            return {
                info: null
            }
        },
        created() {
            this.getApprove();
        },
        methods: {
            getApprove() {
                let detail = this.$store.getters.detail;
                let id = this.id;
                if(detail && detail.type == 'assApprove' && detail.obj.id == id) {
                    this.dealInfo(detail.obj)
                } else {
                    this.getDetail();
                }
            },
            getDetail() {
                let url = `/admin/evaluate-message/${this.$route.params.id}?expand=item.message`;
                this.$axios(url).then(this.dealInfo);
            },
            dealInfo(info) {
                this.info = info;
            }
        }
    }
</script>

<style scoped>

</style>
